import { useCallback, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Select } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { resetPatientLists } from 'stores/patients/patientsSlice';
import { useAppDispatch, useAppSelector } from 'stores/hooks';
import AgendaComponent from 'components/agenda/AgendaComponent';
import { getUserList, getUsersAsync } from 'stores/admin/adminSlice';

export default function AdminAsDoctorAgenda() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { doctorID } = useParams();
  const doctors = useAppSelector(getUserList);
  const selectDoctorOptions = useMemo(() => doctors?.map((doctor) => ({
    value: doctor.wp_id?.toString(),
    label: `Dr ${doctor.lastName} ${doctor.firstName}`,
  })) || [], [doctors]);
  const onChangeSelectedDoctor = useCallback((newDoctorID: string) => {
    navigate(`/admin/agenda/${newDoctorID}`);
  }, [navigate]);

  useEffect(() => {
    dispatch(getUsersAsync());
    return () => {
      dispatch(resetPatientLists());
    };
  }, [dispatch]);

  return (
    <AgendaComponent
      admin
      doctorID={doctorID}
      title={(
        <div className='flex items-center space-x-4'>
          <Link to='/admin'>
            <Button
              type='text'
              className='!w-32 !inline-flex !items-center'
              icon={<ArrowLeftOutlined />}
            >
              <span>Retour</span>
            </Button>
          </Link>
          {selectDoctorOptions.length > 0 && (
            <Select
              className='min-w-[180px]'
              options={selectDoctorOptions}
              defaultValue={doctorID}
              onChange={onChangeSelectedDoctor}
            />
          )}
        </div>
      )}
    />
  );
}
